<template>
  <div class="form-detail">
    <h1 class="ml-1 form-inner-heading d-inline-flex justify-content-between align-items-center">
      <span>File phụ lục QR quốc tế - {{ item.code }}</span>
      <button :disabled="!canSaved" @click="uploadFiles" v-if="files" class="btn btn-success">
        Lưu
      </button>
    </h1>
    <div class="flex-wrap d-flex" style="gap: 10px">
      <!-- :maxFile="1" -->
      <UploadMultiple
        :lsData="item.multiUrlPDF"
        fileType="file"
        keyUrl="urlPDF"
        uniqueKey="urlPDFs"
        accept="application/pdf, application/vnd.ms-excel"
        @syncFile="(fileUploads, uniqueKey) => syncFiles(fileUploads, uniqueKey, item)"
        :canUpload="
          item.state === 'SIGNED_WAITING_APPROVED' && contract.formContract === 'PAPER_CONTRACT'
        "
        title="File phụ lục PDF"
      />
      <UploadMultiple
        :lsData="[item.appendixQr.appendixImage.url]"
        :canUpload="false"
        :title="`Ảnh cửa hàng - Địa điểm: ${item.appendixQr.appendixImage.address || ''}`"
      />
      <UploadMultiple
        :lsData="item.appendixQr.identityCardUrls"
        :canUpload="false"
        title="Ảnh CCCD/CMNND/HC"
      />
      <UploadMultiple
        :lsData="item.appendixQr.ggMapUrls"
        uniqueKey="ggMapUrls"
        @syncFile="(fileUploads, uniqueKey) => syncFiles(fileUploads, uniqueKey, item)"
        :canUpload="
          item.state === 'SIGNED_WAITING_APPROVED' && contract.formContract === 'PAPER_CONTRACT'
        "
        title="Ảnh Google Map"
      />
      <UploadMultiple
        :lsData="item.appendixQr.storeUrls"
        :canUpload="false"
        title="Ảnh biển hiệu, quầy,..."
      />
      <UploadMultiple
        :lsData="item.appendixQr.stickerUrls"
        :canUpload="false"
        title="Ảnh sticker/standeee"
      />
      <UploadMultiple
        v-if="item.additionalUrls && item.additionalUrls.length"
        :lsData="item.additionalUrls"
        :canUpload="false"
        title="File do Sale admin bổ sung sau"
      />
    </div>
    <template
      v-if="item.state === 'APPROVED' && dataPermission.includes('CNPS_SCON_APPENDIX_EDIT_FILE')"
    >
      <b-button v-if="!showUploadMore" variant="primary" @click="showUploadMore = true"
        >Bổ sung file/ảnh</b-button
      >
      <template v-else>
        <UploadMultiple
          :lsData="filesUploadMore.urls"
          uniqueKey="urls"
          @syncFile="(fileUploads, uniqueKey) => upMoreFile(fileUploads, uniqueKey, item)"
          :canUpload="true"
          title="Chọn file/ảnh"
        />
        <div class="d-flex justify-content-end">
          <b-button variant="" @click="cancelUploadMore">Huỷ bỏ</b-button>
          <b-button
            class="ml-2"
            variant="primary"
            @click="submitUploadMore"
            :disabled="filesUploadMore.urls.length === 0"
            >Đồng bộ sang MPOS</b-button
          >
        </div>
      </template>
    </template>
    <VueLoadingOverlay
      style="z-index: 5 !important"
      :active.sync="showLoading"
      :is-full-page="false"
    ></VueLoadingOverlay>
  </div>
</template>
<script>
  import { ContractService } from '@/services/contract.service'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import cloneDeep from 'lodash/cloneDeep'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { UploadMultiple },
    data() {
      return {
        showLoading: false,
        files: null,
        filesUploadMore: {
          urls: [],
          appendixId: null,
        },
        showUploadMore: false,
      }
    },
    computed: {
      canSaved() {
        return this.files && this.files.urlPDFs.length > 0 && this.files.ggMapUrls.length > 0
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      cancelUploadMore() {
        this.filesUploadMore = {
          urls: [],
          appendixId: null,
        }
        this.showUploadMore = false
      },
      upMoreFile(fileUploads, uniqueKey, item) {
        this.filesUploadMore = {
          urls: fileUploads,
          appendixId: item.appendixId,
        }
      },
      async submitUploadMore() {
        try {
          this.showLoading = true
          let allUrls = this.item?.additionalUrls ?? []
          allUrls = [
            ...allUrls,
            ...(await Promise.all(this.filesUploadMore.urls.map(s => this.sendFile(s)))),
          ]
          const params = {
            appendixId: this.filesUploadMore.appendixId,
            urls: allUrls,
          }
          const res = await ContractService.additionalUpload(params)
          if (res.success) {
            this.cancelUploadMore()
            this.showSuccessMx(
              `Đã bổ sung cho File phụ lục QR quốc tế ${this.item.code} thành công`
            )
            this.item.additionalUrls = allUrls
          } else this.showFailMx(res.message ?? res.error)
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },

      syncFiles(fileUploads, uniqueKey, item) {
        if (!this.files) {
          this.files = cloneDeep({
            appendixId: item.appendixId,
            urlPDFs: item.multiUrlPDF ?? [],
            ggMapUrls: item.appendixQr.ggMapUrls ?? [],
          })
        }
        this.files[uniqueKey] = cloneDeep(fileUploads)
      },
      async sendFile(item, type) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          try {
            let data
            if (type === 'video' || type === 'pdf') {
              data = await ContractService.uploadFileS3PDF(formData)
            } else {
              data = await CommonService.uploadImg(formData)
            }
            const urlFile = data.data[0]
            item.url = urlFile
            item.status = 'uploaded'
            return urlFile
          } catch (error) {
            this.showFailMx(error.message ?? error)
          }
        } else return item.url ?? item
      },
      async uploadFiles() {
        this.showLoading = true
        try {
          const params = {
            appendixId: this.files.appendixId,
            urlPDFs: await Promise.all(this.files.urlPDFs.map(s => this.sendFile(s, 'pdf'))).then(
              s =>
                s.map(item => {
                  if (typeof item === 'object' && item.urlPDF) {
                    return item.urlPDF
                  }
                  return item
                })
            ),
            ggMapUrls: await Promise.all(this.files.ggMapUrls.map(s => this.sendFile(s))),
          }
          const res = await ContractService.editFiles(params)
          if (res.success) {
            this.files = null
            this.showSuccessMx(`Cập nhật cho File phụ lục QR quốc tế ${this.item.code} thành công`)
          } else this.showFailMx(res.message ?? res.error)
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
